import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";

import { IRegion } from "../interfaces/iregion";
import { ApplicationSettingsService } from "./applicationsettings.service";
import { BaseService } from "./base.service";
import { AuthService } from "./auth.service";

/**
 * @WhatItDoes A service to get the regions data.
 *
 * @HowToUseIt Inject the service
 */
@Injectable()
export class RegionService extends BaseService {

    /**
     * Constructor for service
     * @param http angular http module
     * @param applicationSettings Application Settings Service. This allows to fetch the url from configuration settings.
     */
    constructor(http: HttpClient, private applicationSettings: ApplicationSettingsService, authService: AuthService, toastsManager: ToastrService) {
        super(http, authService, toastsManager);
    }

    /**
     * Returns an observable list of region
     */
    getRegions(): Observable<IRegion[]> {
        return super.get(`${this.applicationSettings.apiUrl}Region`);
    }
}